// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { PartnerOut } from './partnerOut.zod.ts';

export const PartnerListOut = zod.object({
  "partners": zod.array(PartnerOut)
});

export type PartnerListOut = zod.input<typeof PartnerListOut>;
export type PartnerListOutOutput = zod.output<typeof PartnerListOut>;
